import {Injectable} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ReportType} from '../models/report-type.model';
import {CALENDAR_MONTH_OFFSET, DATE_FORMAT, FLEXIBLE_REPORT_TAB} from './report-datepicker.constants';
import {ReportDatepickerGroupReportCoordinator} from './report-datepicker-group-report.coordinator';
import {ReportDatepickerPersonalReportCoordinator} from './report-datepicker-personal-report.coordinator';
import {
  ReportDatepickerReportView,
  ReportPeriod,
  ReportRequestContext
} from './report-datepicker.types';
import {ReportDatepickerVectorReportCoordinator} from './report-datepicker-vector-report.coordinator';

@Injectable()
export class ReportDatepickerStandardRequestCoordinator {
  constructor(
    private personalReports: ReportDatepickerPersonalReportCoordinator,
    private groupReports: ReportDatepickerGroupReportCoordinator,
    private vectorReports: ReportDatepickerVectorReportCoordinator
  ) {
  }

  prepare(view: ReportDatepickerReportView): ReportRequestContext {
    this.resetErrors(view);
    this.personalReports.clearRowNames();
    const fromDate = this.date(view.from);
    const toDate = this.date(view.to);
    if (view.currentTab !== FLEXIBLE_REPORT_TAB && toDate < fromDate) {
      view.dateErrorContent = true;
      return null;
    }
    const context = {
      from: moment(fromDate).format(DATE_FORMAT),
      to: moment(toDate).format(DATE_FORMAT),
      fromDate: fromDate
    };
    this.personalReports.resetReports();
    return context;
  }

  dispatch(view: ReportDatepickerReportView, context: ReportRequestContext): void {
    switch (view.reportType) {
      case ReportType.BY_DAY_OFF:
        return this.personalReports.requestDayOff(view, context);
      case ReportType.BY_DAY_OFF_GROUP:
        return this.personalReports.requestGroupDayOff(view, context);
      case ReportType.BY_USER:
        return this.personalReports.requestPersonal(view, context, false);
      case ReportType.BY_USER_DEP:
        return this.personalReports.requestPersonal(view, context, true);
      case ReportType.BY_GROUP:
        return this.groupReports.start(view, this.period(context));
      case ReportType.BY_VECTOR:
        return this.vectorReports.requestGroup(view, context);
      case ReportType.BY_VECTOR_ALL_GROUP:
        return this.vectorReports.requestAll(view, context);
      default:
        return this.vectorReports.navigateToDashboard();
    }
  }

  startGroup(view: ReportDatepickerReportView, period: ReportPeriod): void {
    this.groupReports.start(view, period);
  }

  cancelGroup(view: ReportDatepickerReportView): void {
    this.groupReports.cancel(view);
  }

  destroy(): void {
    this.groupReports.destroy();
    this.personalReports.destroy();
  }

  private resetErrors(view: ReportDatepickerReportView): void {
    view.payrollOperationPending = view.wrongError = view.wrongError409 = false;
    view.suc = false;
    view.wrongIntervalError = false;
    view.noScheduleError = false;
    view.emptyIntervalError = false;
  }

  private period(context: ReportRequestContext): ReportPeriod {
    return {from: context.from, to: context.to};
  }

  private date(value: NgbDateStruct): Date {
    return new Date(value.year, value.month - CALENDAR_MONTH_OFFSET, value.day);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-standard-request.coordinator.ts